var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{staticClass:"blink",staticStyle:{"height":"120px"},attrs:{"src":require("@/assets/owl-icon.svg"),"alt":""}})}
var staticRenderFns = []

export { render, staticRenderFns }